/*
 * OOO Main Product — Create-style buy box interactions (section-scoped, deferred).
 *  - Gallery thumb -> main image swap (fallback path; slick drives real media).
 *  - Size selector (3/2/1) -> quantity + per-day + panel prices.
 *  - Autoship / One-time toggle -> selling_plan on/off + primary price.
 *  - Add-to-cart posts id + quantity + selling_plan via ooo-cart.js (FormData).
 *  - Sticky buy box offset measured from #header-group (desktop only).
 */
(function () {
  'use strict';

  function money(cents) {
    var n = (parseInt(cents, 10) || 0) / 100;
    return '$' + n.toFixed(2);
  }

  function initBox(cbx, root) {
    var prices;
    try { prices = JSON.parse(cbx.getAttribute('data-ooo-prices') || '{}'); } catch (e) { prices = {}; }

    var qtyInput = cbx.querySelector('[data-ooo-qty-input]');
    var spInput = cbx.querySelector('[data-ooo-sp-input]');
    var planId = spInput ? String(spInput.value || '').trim() : '';

    var sizeBtns = cbx.querySelectorAll('.ooo-sz');
    var optCards = cbx.querySelectorAll('[data-ooo-opt]');

    /* delivery-frequency pills (SKIO 4/8/12-week plans) -> selected selling_plan */
    var freqPills = cbx.querySelectorAll('[data-ooo-freq-pill]');
    var activeFreq = cbx.querySelector('[data-ooo-freq-pill].is-active') || freqPills[0];
    var freqPlan = activeFreq ? String(activeFreq.getAttribute('data-plan') || '').trim() : planId;

    function render() {
      var size = cbx.getAttribute('data-size') || '3';
      var mode = cbx.getAttribute('data-mode') || 'sub';
      var p = prices[size];
      if (!p) return;

      /* hidden form fields — subscribe posts the selected frequency's plan */
      if (qtyInput) qtyInput.value = size;
      if (spInput) {
        if (mode === 'sub' && freqPlan) { spInput.value = freqPlan; spInput.disabled = false; }
        else { spInput.disabled = true; }
      }

      /* per-day on each size card (reflects selected mode) */
      Array.prototype.forEach.call(sizeBtns, function (b) {
        var bs = b.getAttribute('data-size');
        var bp = prices[bs];
        var pd = b.querySelector('[data-ooo-sz-pd]');
        if (bp && pd) pd.textContent = '(' + money(bp.pdOnce) + ' / Day)';
      });

      /* autoship card: save % badge + subscribe price (strike = list) */
      var savePct = Math.round(100 * (1 - (p.sub / p.list)));
      var saveBadge = cbx.querySelector('[data-ooo-save-badge]');
      if (saveBadge) saveBadge.textContent = savePct + '%';
      var was = cbx.querySelector('.ooo-buy__card [data-ooo-was]');
      if (was) was.textContent = money(p.list);
      var now = cbx.querySelector('[data-ooo-now]');
      if (now) now.textContent = money(p.sub);

      /* one-time row */
      var on = cbx.querySelector('[data-ooo-once-now]');
      if (on) on.textContent = money(p.once);
      var ow = cbx.querySelector('[data-ooo-once-was]');
      if (ow) ow.textContent = money(p.list);

      /* active states */
      Array.prototype.forEach.call(optCards, function (o) {
        var active = o.getAttribute('data-mode') === mode;
        o.classList.toggle('is-active', active);
        o.setAttribute('aria-pressed', active ? 'true' : 'false');
      });

      /* sticky bar price */
      var stickyP = root.querySelector('[data-ooo-sticky-price]');
      if (stickyP) stickyP.innerHTML = '<b>' + money(mode === 'sub' ? p.sub : p.once) + '</b> · ' + (mode === 'sub' ? 'Autoship' : 'One-time');
    }

    /* size selection */
    Array.prototype.forEach.call(sizeBtns, function (b) {
      b.addEventListener('click', function () {
        Array.prototype.forEach.call(sizeBtns, function (x) { x.classList.remove('is-active'); x.setAttribute('aria-pressed', 'false'); });
        b.classList.add('is-active'); b.setAttribute('aria-pressed', 'true');
        cbx.setAttribute('data-size', b.getAttribute('data-size'));
        render();
      });
    });

    /* autoship / one-time toggle */
    Array.prototype.forEach.call(optCards, function (o) {
      var select = function () { cbx.setAttribute('data-mode', o.getAttribute('data-mode')); render(); };
      o.addEventListener('click', function (e) {
        /* don't hijack the CTA button inside the autoship card */
        if (e.target.closest('.ooo-buy__cta')) return;
        select();
      });
      o.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); select(); } });
    });

    /* delivery-frequency selection (picking a frequency implies Subscribe) */
    Array.prototype.forEach.call(freqPills, function (pill) {
      pill.addEventListener('click', function (e) {
        e.stopPropagation();
        Array.prototype.forEach.call(freqPills, function (x) { x.classList.remove('is-active'); x.setAttribute('aria-checked', 'false'); });
        pill.classList.add('is-active'); pill.setAttribute('aria-checked', 'true');
        freqPlan = String(pill.getAttribute('data-plan') || '').trim();
        cbx.setAttribute('data-mode', 'sub');
        render();
      });
    });

    render();

    /* sticky add-to-cart bar: show once the main CTA scrolls above the viewport */
    var mainCta = cbx.querySelector('.ooo-buy__cta');
    var bar = root.querySelector('[data-ooo-stickybar]');
    if (mainCta && bar && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        var e = entries[0];
        var show = !e.isIntersecting && e.boundingClientRect.top < 0;
        bar.classList.toggle('is-visible', show);
        bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      }, { threshold: 0 });
      io.observe(mainCta);
    }
  }

  function init() {
    var roots = document.querySelectorAll('[data-ooo-main-product]');
    Array.prototype.forEach.call(roots, function (root) {

      /* gallery thumb swap (fallback path) */
      var mainImg = root.querySelector('#oooGalleryMain');
      var thumbs = root.querySelectorAll('[data-ooo-thumb]');
      Array.prototype.forEach.call(thumbs, function (t) {
        t.addEventListener('click', function () {
          Array.prototype.forEach.call(thumbs, function (x) { x.classList.remove('is-active'); });
          t.classList.add('is-active');
          if (mainImg && t.dataset.full) mainImg.src = t.dataset.full;
        });
      });

      /* buy box */
      var cbx = root.querySelector('.ooo-cbx');
      if (cbx) initBox(cbx, root);

      /* bundle "Add all" -> add every product at once + auto-apply the (non-combining) bundle code -> open side cart */
      var bundleAdd = root.querySelector('[data-ooo-bundle-add]');
      if (bundleAdd) {
        bundleAdd.addEventListener('click', function (e) {
          e.preventDefault();
          var vids = (bundleAdd.dataset.variants || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
          var code = (bundleAdd.dataset.code || '').trim();
          if (!vids.length) return;
          bundleAdd.setAttribute('aria-busy', 'true');
          var items = vids.map(function (id) { return { id: Number(id), quantity: 1 }; });
          fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
            .then(function () { return code ? fetch('/discount/' + encodeURIComponent(code), { method: 'GET' }).catch(function () {}) : null; })
            .then(function () { if (window.OOOCart) return window.OOOCart.refresh().then(window.OOOCart.open); })
            .finally(function () { bundleAdd.removeAttribute('aria-busy'); });
        });
      }

      /* sticky buy box offset under the custom header */
      var gallery = root.querySelector('[data-ooo-gallery]');
      var buy = root.querySelector('[data-ooo-buy]');
      var setStickyTop = function () {
        var hg = document.querySelector('#header-group');
        var desktop = window.matchMedia('(min-width: 1025px)').matches;
        [gallery, buy].forEach(function (el) {
          if (!el) return;
          if (hg && desktop) { el.style.top = (hg.offsetHeight + 16) + 'px'; }
          else { el.style.top = ''; }
        });
      };
      setStickyTop();
      window.addEventListener('resize', setStickyTop);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
